/**
 * R18-10 — Room Full full-page card.
 *
 * Shown when `POST /api/rooms/{id}/token` returns 410 `room_full`. Renders a
 * blocking screen with retry + back-to-dashboard CTAs.
 *
 * Testids:
 *   - room-full-screen
 *   - room-full-retry-btn
 *   - room-full-back-btn
 */
import React from "react";
import { Users, Loader2 } from "lucide-react";

export default function RoomFullCard({ cap, onRetry, onBack, retrying }) {
  return (
    <div className="min-h-screen grid place-items-center bg-[#050508] text-white p-6"
         data-testid="room-full-screen">
      <div className="max-w-md w-full sr-glass rounded-2xl p-7 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-amber-500/15 grid place-items-center mb-4">
          <Users className="w-7 h-7 text-amber-300" />
        </div>
        <h1 className="font-display text-2xl font-black mb-2">This room is full</h1>
        <p className="text-sm text-white/70 leading-relaxed mb-6">
          {typeof cap === "number"
            ? <>The host capped this room at <strong>{cap}</strong> participants and every spot is taken right now.</>
            : <>Every spot in this room is taken right now.</>}
          {" "}A seat opens up as soon as someone leaves — try again in a minute.
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            onClick={onRetry}
            disabled={!!retrying}
            className="flex-1 bg-gradient-to-r from-[#FF007F] to-[#00F0FF] text-white font-bold rounded-lg px-5 py-2.5 hover:opacity-90 disabled:opacity-40 inline-flex items-center justify-center gap-2"
            data-testid="room-full-retry-btn"
          >
            {retrying ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Try again
          </button>
          <button
            type="button"
            onClick={onBack}
            className="flex-1 bg-white/5 hover:bg-white/10 border border-white/10 text-white rounded-lg px-5 py-2.5 font-semibold"
            data-testid="room-full-back-btn"
          >
            Back to dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
